module.exports = __webpack_public_path__ + "img/lr_1.8a7132b2.png";